import React, { useState } from 'react';
import "./HistoryTab.css";
import "./../LoyalitySchemeAccordion.css";

const HistoryTab = ({ redemptionHistory }) => {
  const [search, setSearch] = useState(''); 
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const filteredHistory = redemptionHistory?.filter((item) =>
    item.reward.toLowerCase().includes(search.toLowerCase()) ||
    item.restaurantName.toLowerCase().includes(search.toLowerCase())
  ) || [];

  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentHistory = filteredHistory.slice(startIndex, startIndex + itemsPerPage);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div className="history-section">
      <div className="section-header">
        <div className="header-with-icon">
          {/* <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg> */}
          <h2 className="loyalty-title">Redemption History</h2>
        </div>
        <input
          type="text"
          placeholder="Search redemptions..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="loyalty-search-input"
        />
      </div>
      <div className="history-table">
        {currentHistory.length > 0 ? (
          currentHistory.map((item, index) => (
            <div className="history-row" key={index}>
              <div className="history-info">
                <h4>{item.reward}</h4>
                <p>{item.restaurantName}</p>
              </div>
              <div className="history-meta">
                <span className="history-points">
                  -{item.redeemedPoints} pts
                </span>
                <span className="history-date">
                  {/* {new Date(item.redemptionDate).toLocaleString()} */}
                  {new Date(item.redemptionDate).toLocaleString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            {search
              ? "No redemptions found matching your search."
              : "No redemption found."}
          </div>
        )}
      </div>
      {filteredHistory.length > 0 && (
        <div className="pagination">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            Previous
          </button>
          <span className="page-info">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default HistoryTab;